import React, { useEffect } from "react"
import { FieldName, ReplyCodeText } from "../common/text"
import { IDateFieldProperties } from "./generic/fields"
import DropdownField from "./generic/form/DropdownField"

interface Props extends IDateFieldProperties {
  replyCode: string
  replyOptions: string[]
  onChangeCode: (name: string, value: any, isValid: boolean) => void
}

const ReplyCodeField: React.FunctionComponent<Props> = ({
  replyCode,
  replyOptions,
  onChangeCode
}) => {
  useEffect(() => {
    if (replyCode === "") {
      onChangeCode("replyCode", replyOptions[0], true)
    }
  }, [replyCode, replyOptions, onChangeCode])

  const isClearable = replyOptions.includes("*")

  const handleGetReplyCodeOptLabel = (replyCode: string): string => {
    switch (replyCode) {
      case "A":
        return ReplyCodeText.A
      case "P":
        return ReplyCodeText.P
      case "C":
        return ReplyCodeText.C
      case "S":
        return ReplyCodeText.S
      case "O":
        return ReplyCodeText.O
      case "R":
        return ReplyCodeText.R
      case "L":
        return ReplyCodeText.L
      default:
        return replyCode
    }
  }

  const handleChange = (name: string, val: any) => {
    const _val = val === null ? "*" : val
    onChangeCode(name, _val, false)
  }

  const replyCodeOpts = replyOptions
    .filter((o) => o !== "*")
    .map((o) => ({
      label: handleGetReplyCodeOptLabel(o),
      value: o
    }))

  return (
    <DropdownField
      name={FieldName.replyCode}
      options={replyCodeOpts}
      value={replyCode}
      clearable={isClearable}
      closeOnSelect
      onChange={handleChange}
    />
  )
}

export default ReplyCodeField
